import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './lib/posthog' // Initialize PostHog

// Register service worker for PWA (sound and notifications)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    console.log('Initializing service worker...');

    // Use a stable URL without cache-busting to avoid unnecessary updates
    const swUrl = '/sw.js?v=' + Date.now();

    navigator.serviceWorker.register(swUrl)
      .then((registration) => {
        console.log('SW registered successfully:', registration.scope);

        // Listen for state changes
        if (registration.installing) {
          console.log('SW installing state:', registration.installing.state);
          registration.installing.addEventListener('statechange', (event) => {
            console.log('SW installing state changed to:', event.target.state);
          });
        }

        if (registration.waiting) {
          console.log('SW waiting available');
        }

        if (registration.active) {
          console.log('SW active available, state:', registration.active.state);
        }

        // Check for updates periodically
        setInterval(() => {
          registration.update().catch(err => {
            console.log('SW update check failed:', err.message);
          });
        }, 1000 * 60 * 60); // Check for updates every hour

        // Handle waiting service workers (updates available)
        if (registration.waiting) {
          console.log('SW update available, activating...');
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Listen for new updates becoming available
        registration.addEventListener('updatefound', () => {
          console.log('SW update found');
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              console.log('SW state changed to:', newWorker.state);
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version ready, activate it
                console.log('Activating new SW version...');
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              } else if (newWorker.state === 'activated') {
                console.log('SW update activated');
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('SW registration failed:', error);
        console.error('SW registration error details:', error.message, error.stack);
      });

    // Handle controller changes (new SW taking over)
    // Disabled automatic reload to prevent infinite loops during testing
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('SW controller changed - new service worker is now active');
      // Note: Automatic reload disabled during testing to prevent loops
      // In production, you might want to reload on major updates
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
